import htttp from "../../../helpers/axios";
import { WorkshopData } from "../../../api";
//import upskill from "../../../upskill";

const state = {
  WorkshopData: []
};

const getters = {
  WorkshopData: state => state.WorkshopData,
  getWorkshopById(state) {
    return id => {
      return state.WorkshopData.find(el => {
        // console.log(el);
        return el.id == id;
      });
    };
  }
};

const mutations = {
  saveWorkshopData(state, payload) {
    state.WorkshopData = payload;
  },
  saveWorkshopDataByID(state, { data, id }) {
    if (!state.WorkshopData.includes(el => el.id == id)) {
      state.WorkshopData.push(data);
    }
  }
};

const actions = {
  GET_WORKSHOPDATA: async ({ commit }) => {
    let { data } = await htttp.get(WorkshopData);
    let ws = data.data.filter(w => w.category !== "Education")
    // upskill.discounts().then(res => {
    //   let discounts = res.data.data;
    //   // console.log(discounts)
    //   discounts.forEach(d => {
    //     let widx = data.data.findIndex(w => w.id == d.WID);
    //
    //     data.data[widx].hasDiscount = true;
    //     data.data[widx].fee = 0;
    //     data.data[widx].discountedPrice =
    //       parseInt(data.data[widx].fee) - parseInt(d.Discount);
    //     // console.log(widx);
    //     // console.log(data.data[widx]);
    //   });
    // });
    commit("saveWorkshopData", ws);
  },
  GET_WORKSHOPDATA_BY_ID: async ({ commit }, id = 0) => {
    let { data } = await htttp.get(`${WorkshopData}/${id}`);
    // console.log(data);
    commit("saveWorkshopDataByID", {
      data: data.data,
      id
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
